const headers = [
  {
    text: 'common.common_transfer-account',
    value: 'name',
    sortable: true,
    width: '69%'
  },
  {
    text: 'user.user_default-currency',
    value: 'defaultCurrencyId',
    sortable: true,
    width: '12%'
  },
  {
    text: 'common.input_sort-number',
    value: 'sortNumber',
    sortable: true,
    width: '9%'
  },
  {
    text: 'payment.payment_operation',
    value: 'editAndDelete',
    sortable: false,
    width: '13%'
  }
]
export default { headers }
